import { PrintableIframeComponent } from './components/printable-iframe/printable-iframe.component';
import { NgModule } from '@angular/core';
import { PrintService } from './services/print.service';
import { MojoPrintImmediate } from './directive/mojo-print-immediate';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    MojoPrintImmediate,
    PrintableIframeComponent
  ],
  exports: [
    MojoPrintImmediate,
    PrintableIframeComponent
  ],
  imports: [
    CommonModule
  ],
  providers: [
    PrintService
  ]
})
export class PrintingModule { }
